import {
  Stack,
  Typography,
  FormControl,
  TextField,
  FormHelperText,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Switch,
  FormControlLabel,
} from '@mui/material';
import { type Control, Controller } from 'react-hook-form';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WaterDropIcon from '@mui/icons-material/WaterDrop';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';
import { getFormErrorAttributes } from '#apps/client-web/app/helpers/react-hook-form';

export type DCWFieldsProps = {
  control: Control<EditAuditFormBackgroundData>;
  disableForm: boolean;
};

export const DCWFields = ({ control, disableForm }: DCWFieldsProps) => {
  return (
    <Accordion variant="outlined">
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header">
        <Stack direction="row" alignItems="center" spacing={1}>
          <WaterDropIcon fontSize="small" />
          <Typography variant="body1">Domestic Cool Water</Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={3}>
          <Controller
            control={control}
            name="domesticColdWater.otherWaterLoads"
            disabled={disableForm}
            rules={{ maxLength: 120 }}
            render={({ field, fieldState }) => (
              <FormControl
                fullWidth
                {...getFormErrorAttributes(fieldState.error)}>
                <TextField
                  {...field}
                  label="Other water loads"
                  type="text"
                  multiline
                  rows={2}
                  variant="outlined"
                  {...getFormErrorAttributes(fieldState.error)}
                />
                <FormHelperText>{fieldState.error?.message}</FormHelperText>
              </FormControl>
            )}
          />
          <Controller
            control={control}
            name="domesticColdWater.hadPipeLeaks"
            disabled={disableForm}
            render={({ field, fieldState }) => (
              <FormControl
                fullWidth
                {...getFormErrorAttributes(fieldState.error)}>
                <FormControlLabel
                  control={<Switch {...field} checked={field.value || false} />}
                  label="Had pipe leaks?"
                  labelPlacement="start"
                  sx={{
                    justifyContent: 'space-between',
                    ml: 0,
                  }}
                />
                <FormHelperText>{fieldState.error?.message}</FormHelperText>
              </FormControl>
            )}
          />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
